<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-5 pa-5" align="center" justify="center">
      <v-col cols="12" sm="11" md="10" lg="9">
        <v-sheet
          class="mo-panel elevation-0 rounded-l mx-auto"
          max-width="1000"
        >
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6">
              <div class="d-flex align-center mb-4">
                <v-btn small class="neo-btn back-btn" @click="goBack">
                  <v-icon left small>mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
              </div>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-card
                    class="menu-card elevation-2"
                    :ripple="true"
                    @click="onNormal"
                  >
                    <v-card-text class="py-6 d-flex align-center">
                      <v-avatar size="52" class="mr-4 avatar-soft primary">
                        <v-icon color="white">mdi-format-list-bulleted</v-icon>
                      </v-avatar>
                      <div>
                        <div class="menu-title">Normal Loading</div>
                        <div class="menu-desc">
                          Proses loading barang standar
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-icon color="#64B5F6">mdi-chevron-right</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card
                    class="menu-card elevation-2"
                    :ripple="true"
                    @click="onSpread"
                  >
                    <v-card-text class="py-6 d-flex align-center">
                      <v-avatar size="52" class="mr-4 avatar-soft success">
                        <v-icon color="white">mdi-view-grid-plus</v-icon>
                      </v-avatar>
                      <div>
                        <div class="menu-title">Spread Loading</div>
                        <div class="menu-desc">
                          Proses loading barang gabungan
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <v-icon color="#81C784">mdi-dots-horizontal</v-icon>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LotCheckerDashboard',
  methods: {
    goBack() {
      this.$router.push({ name: 'manufactureDashboard' })
    },
    onNormal() {
      try {
        if (this.$router) {
          this.$router.push({ name: 'lotCheckerNormal' })
          return
        }
      } catch (e) {}
      this.$emit('choose', 'normal')
      this.$swal &&
        this.$swal.fire('Info', 'Menu NORMAL LOADING dipilih.', 'info')
    },
    onSpread() {
      try {
        if (this.$router) {
          this.$router.push({ name: 'lotCheckerSpread' })
          return
        }
      } catch (e) {}
      this.$emit('choose', 'spread')
      this.$swal &&
        this.$swal.fire('Info', 'Menu SPREAD LOADING dipilih.', 'info')
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const container = canvas.parentElement
      const w = container.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144, 202, 249, 0.35)')
      g1.addColorStop(1, 'rgba(144, 202, 249, 0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165, 214, 167, 0.35)')
      g2.addColorStop(1, 'rgba(165, 214, 167, 0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.menu-stack {
  padding-top: 12vh;
}
.menu-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
}
.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 16px 18px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
.neo-btn.v-btn:hover {
  box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.1), -10px -10px 20px var(--hi) !important;
}
.neo-btn.v-btn:active {
  box-shadow: inset 6px 6px 14px rgba(0, 0, 0, 0.08),
    inset -6px -6px 14px var(--hi) !important;
}
.menu-card {
  border: 1px solid rgba(144, 202, 249, 0.25);
  border-radius: 14px;
  transition: transform 0.12s ease, box-shadow 0.15s ease,
    border-color 0.12s ease;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}
.menu-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08) !important;
  border-color: rgba(144, 202, 249, 0.55);
}
.menu-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #263238;
}
.menu-desc {
  font-size: 0.92rem;
  color: #607d8b;
}
.avatar-soft.primary {
  background: linear-gradient(135deg, #64b5f6, #90caf9);
}
.avatar-soft.success {
  background: linear-gradient(135deg, #81c784, #a5d6a7);
}
.back-btn {
  padding-left: 12px !important;
  padding-right: 14px !important;
}
</style>
